/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { Search200ResponseData } from './Search200ResponseData'
import {
  Search200ResponseDataFromJSON,
  Search200ResponseDataFromJSONTyped,
  Search200ResponseDataToJSON,
} from './Search200ResponseData'

/**
 *
 * @export
 * @interface Search200Response
 */
export interface Search200Response {
  /**
   *
   * @type {boolean}
   * @memberof Search200Response
   */
  status: boolean
  /**
   *
   * @type {Search200ResponseData}
   * @memberof Search200Response
   */
  data: Search200ResponseData
}

/**
 * Check if a given object implements the Search200Response interface.
 */
export function instanceOfSearch200Response(
  value: object
): value is Search200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function Search200ResponseFromJSON(json: any): Search200Response {
  return Search200ResponseFromJSONTyped(json, false)
}

export function Search200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Search200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: Search200ResponseDataFromJSON(json['data']),
  }
}

export function Search200ResponseToJSON(value?: Search200Response | null): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: Search200ResponseDataToJSON(value['data']),
  }
}
